module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DataTablePage', {
    attrs: {
      "mainColumn": "name",
      "longColumn": "remark",
      "resource": "meterReading/readingUser",
      "title": "抄表员管理",
      "label": "抄表员",
      "labelName": "loginName",
      "toolbar": _vm.toolbar,
      "operation": _vm.operation,
      "operationWidth": 70,
      "tableFullList": _vm.tableFullList,
      "tableInitList": _vm.tableInitList,
      "filterFullList": _vm.filterFullList,
      "filterInitList": _vm.filterInitList,
      "updateList": _vm.updateList,
      "createList": _vm.createList,
      "columns": _vm.columns
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69a535ee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/containers/MeterReading/Account.vue
// module id = 1769
// module chunks = 1